<!-- v1 imageLibrary.html root ftLoadingAnimation {trigger: isProcessingUpload, message: ProcessingImage,
     display: 'block'} — dark theme + disableUi defaults: while processing, the block overlay div enters
     as the panel's LAST child and the panel gets pointer-events:none + disabled. -->
<div
  class="imageLibrary-panel"
  [style.pointer-events]="isProcessingUpload() ? 'none' : null"
  [attr.disabled]="isProcessingUpload() ? 'disabled' : null"
>
  <ul class="imageLibrary-tabs nav nav-pills nav-justified">
    <li [class.active]="view() === 'list'"><a (click)="view.set('list')">{{ 'flipto.account.components.imageLibrary.Library' | translate }}</a></li>
    <li [class.active]="view() === 'upload'"><a (click)="view.set('upload')">{{ 'flipto.account.components.imageLibrary.Upload' | translate }}</a></li>
    <li [class.active]="view() === 'upload-from-url'"><a (click)="view.set('upload-from-url')">{{ 'flipto.account.components.imageLibrary.ImageUrl' | translate }}</a></li>
  </ul>

  <!-- LIST (imageList.html) -->
  <div [hidden]="view() !== 'list'">
    <div class="imageLibrary-content">
      <div class="instructions">{{ 'flipto.account.components.imageLibrary.ChooseFromImages' | translate }}</div>
      <!-- Gapless @for: v1 ng-repeat appends the inline-block <a.image> clones adjacently;
           with preserveWhitespaces:true any whitespace inside the block paints a ~4px gap. -->
      <div class="image-list">
        @for (image of images(); track image) {<a
            class="image"
            (click)="showPreview(image)"
            [attr.alt]="image.name"
            [style.background-image]="bgUrl(image.url)"
          ></a>}
      </div>
    </div>
  </div>

  <!-- PREVIEW (imagePreview.html) -->
  <div [hidden]="view() !== 'preview'">
    <div class="imageLibrary-content">
      <a class="ft-btn ft-btn-outline-dark btn-back" (click)="useDifferentImage()">{{ 'flipto.account.components.imageLibrary.UseDifferentImage' | translate }}</a>
      <div class="image-preview"><img [src]="selectedImage()?.url" [attr.alt]="selectedImage()?.name" /></div>
      <div class="image-label">{{ selectedImage()?.name }}</div>
    </div>
  </div>

  <!-- UPLOAD (imageUpload.html) -->
  <div [hidden]="view() !== 'upload'">
    <div #dropzone class="imageLibrary-content">
      <div class="dropzone dz-message" style="text-align: center;">
        <div class="instructions">{{ 'flipto.account.components.imageLibrary.ImageUploadMessage' | translate }}</div>
      </div>
      <div class="error" [hidden]="!uploadFailed()">{{ 'flipto.account.components.imageLibrary.ImageUploadErrorMessage' | translate }}</div>
    </div>
  </div>

  <!-- UPLOAD FROM URL (imageUploadFromUrl.html) -->
  <div [hidden]="view() !== 'upload-from-url'">
    <div class="imageLibrary-content">
      <div class="url-form">
        <div class="instructions">{{ 'flipto.account.components.imageLibrary.EnterImageUrl' | translate }}</div>
        <div class="url-input">
          <input class="form-control" type="text" [(ngModel)]="imageUrl" />
          <button class="ft-btn ft-btn-default" (click)="uploadFromUrl()">{{ 'flipto.account.components.imageLibrary.Go' | translate }}</button>
        </div>
      </div>
    </div>
  </div>

  @if (isProcessingUpload()) {
    <div class="ft-loading-animation-dark">{{ 'flipto.account.ProcessingImage' | translate }} <span class="ft2-spinner"></span></div>
  }
</div>
